/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    global: {
        '*': {
            WebkitTapHighlightColor: 'transparent'
        },
        'html, body': {
            background: 'bodybgColor',
            color: 'textColor',
            fontFamily: `'Lato'`,
            fontSize: 'md'
        },
        '.page-color-inverted-theme': {
            background: 'bodybgColorInverted',
            color: 'textColor'
        },
        html: {
            scrollbarGutter: 'stable'
        },
        body: {
            minHeight: '100vh'
        },
        '.react-target': {
            display: 'flex',
            minHeight: '100vh'
        },
        img: {
            maxHeight: '100%'
        },
        '.categoryMessage': {
            lineHeight: '15px',
            fontSize: '12px',
            color: '#141519',
            marginTop: ['11px', '0'],
            marginBottom: '11px',
            fontWeight: '400'
        },

        '.sticky-content': {
            position: 'sticky',
            top: '130px',
            height: 'fit-content',
            zIndex: '1'
        },

        '.crunchyTheme .svg-filter-color': {
            // used to change color of svg
            filter: 'invert(1)'
        },
        '.crunchyTheme [data-testid="login-page"], .crunchyTheme [data-testid="reset-password-page"]':
            {
                color: 'black'
            },
        '#login-form p, .register-form p, .crunchyTheme [data-testid="login-page"] p, .crunchyTheme [data-testid="reset-password-page"] p, [data-testid="sf-auth-modal-form"] p':
            {
                // to avoid override, used id
                lineHeight: '32px'
            },
        '.color-black': {
            // do not change the value, if required remove className in component level
            color: 'black !important'
        },
        '.white-color': {
            // do not change the value, if required remove className in component level
            color: 'white'
        },
        '.crunchyTheme .text-color-invert': {
            // used for crunchy theme
            color: 'textColorInverted'
        },
        '.crunchyTheme [data-testid="wishlist-button"]': {
            color: 'textColorInvert',
            background: 'bodybgColorInverted'
        },
        '.crunchyTheme .text-color': {
            color: 'textColor'
        },
        '.chakra-alert': {
            padding: '12px 20px !important',
            borderRadius: '3px !important'
        },
        '[data-status="success"]': {
            color: '#004714 !important',
            backgroundColor: '#cce7d4 !important'
        },
        '[data-status="error"]': {
            color: '#730e0d !important',
            backgroundColor: '#f5cccc !important'
        },
        '.chakra-alert__icon[data-status="success"]': {
            color: 'successAlertPopColor !important'
        },
        '.chakra-alert[data-status="success"] button[aria-label="Close"] .chakra-icon': {
            color: 'successAlertPopColor'
        },
        '.headerPromoLink': {
            color: '#fff',
            fontSize: '16px',
            lineHeight: '24px',
            float: ['none', 'left'],
            textDecoration: 'none', // Remove underline
            _hover: {textDecoration: 'underline'} // Add hover effect
        },
        '.svod-link-block a': {
            color: 'orangeBaseColor',
            fontSize: '16px',
            lineHeight: 'normal',
            textDecoration: 'none',
            float: 'right',
            fontWeight: '800',
            letterSpacing: '0.2px'
        },
        '.svod-link-block a svg': {
            display: 'inline-block',
            verticalAlign: 'middle'
        },
        '.header-logo-block': {
            padding: {base: '0 0 6px 0', sm: '12px 0'},
            paddingBottom: '13px',
            float: 'left',
            width: '100%',
            background: 'black',
            display: 'flex',
            clear: 'both'
        },
        '.logo-block svg': {
            maxWidth: ['155px', '255px'],
            height: ['20px', '32px']
        },
        '.headerIcons': {
            width: ['40px'],
            height: ['48px !important'],
            textAlign: ['center'],
            lineHeight: ['46px !important'],
            cursor: ['pointer'],
            minWidth: ['initial !important'],
            justifyContent: ['center'],
            alignItems: ['center'],
            _hover: {
                path: {
                    fill: 'orangeBaseColor'
                },

                img: {
                    border: ['2px solid orangeBaseColor !important']
                }
            }
        },
        '.flagicon-link svg': {
            border: '2px solid white',
            borderRadius: '2px',
            _hover: {
                border: '2px solid #ff640a'
            }
        },
        '.popovercontent:hover': {
            display: 'block',
            visibility: 'visible !important'
        },
        '.headerIcons img': {
            border: ['2px solid #fff'],
            borderRadius: ['2px']
        },
        '.mobile-login-button svg': {
            width: '16px',
            height: '16px'
        },
        '.mobile-login-button .right-arrow-icon svg': {
            width: '24px',
            height: '24px'
        },
        '.flagIcon': {
            display: ['flex !important']
        },
        '.userIcon': {
            display: ['none !important', 'none  !important', 'flex !important']
        },
        '.wishlistIcon': {
            display: ['none !important', 'none !important', 'flex !important']
        },
        '.cartIcon': {
            display: ['flex !important']
        },
        '.hamburgerIcon': {
            display: ['flex !important'],
            justifyContent: ['left !important']
        },
        '.site-search-icon-box': {
            height: '48px !important',
            width: '52px !important'
        },
        '.site-search-input-box': {
            padding: '0 64px 0 16px',
            fontSize: '16px !important',
            height: '48px !important',
            borderRadius: '8px !important',
            color: 'darkGunmetal',
            lineHeight: '24px',
            backgroundColor: 'white !important',
            fontWeight: 'medium'
        },
        '.cart-price-block .current-price': {
            fontSize: '16px',
            fontFamily: "'DM Sans', sans-serif",
            fontWeight: 'extrabold',
            lineHeight: '100%',
            letterSpacing: '-0.32px'
        },
        '.cart-price-block .list-price': {
            fontSize: '12px',
            color: 'mediumGray',
            fontFamily: "'DM Sans', sans-serif",
            fontWeight: 'medium',
            lineHeight: '100%',
            letterSpacing: '-0.24px'
        },
        '.desktop-menu-block': {
            clear: 'both',
            float: 'left',
            width: '100%'
        },
        '.mobile-menu-block': {
            clear: 'both',
            float: 'left',
            width: '100%'
        },
        '.mobile-menu-block .mobile-list-menu-items': {
            position: 'absolute',
            width: ['100%', '375px'],
            background: 'textColor',
            padding: '24px 0',
            transition: 'all 0.5s',
            overflowY: 'auto',
            overflowX: 'hidden'
        },
        '.l1-category-list': {
            width: ['100%', '375px'],
            background: 'headerBgColor',
            padding: '0 24px',
            zIndex: 1,
            fontWeight: 'bolder',
            position: 'fixed',
            right: 'unset',
            left: '-100%',
            overflowY: 'auto',
            opacity: '0',
            transition: 'all 0.5s'
        },
        '.l1-category-list.show': {
            left: '0',
            opacity: 1,
            padding: '0 32px'
        },
        '.mobilelistMenuItemTrigger.show': {
            '.level-1-link': {
                color: 'orangeBaseColor'
            }
        },
        '.level-2-heading': {
            borderBottom: ['1px solid #a0a0a0'],
            paddingBottom: ['10px'],
            float: ['left'],
            width: ['100%'],
            marginBottom: ['8px'],
            clear: 'both'
        },
        '.level-2-heading-text': {
            float: 'left',
            color: 'black !important',
            fontSize: '20px !important',
            fontWeight: '800',
            marginBottom: '0'
        },
        '.level-2-heading-link': {
            color: 'black !important',
            fontSize: '16px !important',
            fontWeight: '800',
            float: 'right',
            padding: '0 30px 0 0'
        },
        '.container-flex': {
            display: 'flex',
            alignItems: 'start',
            flexWrap: 'nowrap',
            width: '100%',
            justifyContent: 'space-between'
        },
        '.level-2-link-block': {
            clear: 'both'
        },
        '.level-2-menu-block': {
            width: {base: '30%', lg: '25%'}
        },
        '.menu-category-images': {
            width: {base: 'calc(70% - 32px)', lg: 'calc(75% - 32px)'}
        },
        '.menu-category-images .menu-category-images': {
            width: '100%'
        },
        '.menu-category-images .content-asset': {
            width: '25%',
            marginBottom: '32px',
            float: 'left'
        },
        '.menu-category-images .menu-images-inner-block': {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '0 16px',
            _hover: {
                '.image-src-block': {
                    outline: '4px solid #ff640a'
                },
                '.image-subtext-block': {
                    color: '#ff640a'
                }
            }
        },
        '.menu-images-inner-block .image-src-block': {
            color: 'black',
            display: 'block',
            backgroundPosition: '50%',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            height: '226px',
            width: '100%',
            outline: '4px solid transparent',
            position: 'relative',
            marginBottom: '0',
            borderRadius: '8px'
        },
        '.menu-images-inner-block .image-subtext-block': {
            color: 'black',
            fontSize: '16px',
            lineHeight: 'normal',
            marginTop: '12px',
            padding: '4px',
            fontWeight: '700'
        },
        '.level-1-link': {
            fontWeight: 'extrabold',
            '&.saleColor': {
                color: 'orangeBaseColor'
            },
            _hover: {color: 'orangeBaseColor'}
        },
        '.level-2-link': {
            padding: '12px 0',
            margin: ['0'],
            color: 'black',
            fontSize: 'md',
            fontWeight: '800',
            lineHeight: '5',
            whiteSpace: ['normal'],
            _hover: {color: 'orangeBaseColor'}
        },
        '.footer-email div, .footer-email a': {
            fontSize: '12px',
            color: 'silver',
            lineHeight: '24px',
            fontWeight: '500'
        },
        '.footer-links-section a': {
            color: 'silver',
            _hover: {color: 'white'}
        },
        '.footer-email .heading': {
            color: 'orangeBaseColor',
            fontWeight: '800',
            lineHeight: '16px',
            marginBottom: '8px'
        },
        '.footer-subscribe-section .home-email-signup': {
            maxWidth: ['100%', '100%', '304px']
        },
        '.footer-subscribe-section': {
            flex: ['100%', '100%', '0 0 33.33333333%'],
            maxWidth: ['100%', '100%', '33.33333333%'],
            padding: ['0', '0 16px', '0']
        },
        '.footer-subscribe-section .newsletter-title': {
            fontSize: '20px',
            fontWeight: '800',
            textTransform: 'capitalize',
            marginBottom: '12px',
            lineHeight: '28px',
            color: 'silver'
        },
        '.footer-subscribe-section .newsletter-sub-title': {
            fontSize: '16px',
            fontWeight: '500',
            marginBottom: '12px',
            lineHeight: '24px',
            color: 'silver',
            paddingRight: ['0', '20px', '0']
        },
        '.footer-subscribe-section .email-label': {
            fontSize: '16px',
            fontWeight: '800',
            marginBottom: '4px',
            lineHeight: '24px'
        },
        '.footer-subscribe-section .input-group': {
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'stretch',
            width: '100%'
        },
        '.footer-subscribe-section .input-group .form-control': {
            height: '48px',
            padding: '14px 16px',
            color: '#23252b',
            fontWeight: '500',
            borderRadius: '8px 0 0 8px',
            lineHeight: '20px',
            flex: '1 1 auto'
        },
        '.footer-subscribe-section .input-group .subscribe-email': {
            fontSize: '16px',
            color: '#141519',
            height: '48px',
            lineHeight: '16px',
            textTransform: 'capitalize',
            padding: '16px',
            borderRadius: '0 8px 8px 0',
            backgroundColor: 'orangeBaseColor',
            border: '1px solid orangeBaseColor',
            fontWeight: 700
        },
        '.social-container-pdp .social-icons': {
            gap: '1.25rem',
            '@media (max-width: 1024px)': {
                gap: '4px'
            }
        },
        '.social-container-pdp ul.social-icons li a, .social-container-pdp ul.social-icons li button':
            {
                padding: '0',
                _hover: {
                    backgroundColor: 'unset'
                }
            },
        '.social-container-pdp .social-icons a svg': {
            width: '28px',
            height: 'auto',
            color: 'black'
        },
        '.footer-subscribe-section .newsletter-block': {
            display: ['block', 'flex', 'block']
        },
        '.footer-subscribe-section .newsletter-block .newsletter-section, .footer-subscribe-section .newsletter-block .email-section':
            {
                width: ['100%', '50%', '100%']
            },
        '.slant-down.search-banner': {
            backgroundImage: 'none',
            textAlign: 'center'
        },
        '.slant-down.search-banner img': {
            height: 'auto',
            width: 'auto'
        },
        '.country_footer svg': {
            marginRight: '2px'
        },
        '.country_footer .site-footer__copyright a': {
            color: 'silver'
        },
        '.countdowntimer-inner-block': {
            '.image-block': {
                '& + .countdowntimer-text-timer-block': {
                    width: [
                        'calc(100% - 80px)',
                        'calc(100% - 115px)',
                        'calc(100% - 115px)',
                        'calc(100% - 144px)'
                    ],
                    marginLeft: '0px'
                }
            },
            '.clock-block': {
                span: {
                    color: '#4b4b4b',
                    textAlign: 'center',
                    fontSize: ['20px', '28px'],
                    fontWeight: 700,
                    lineHeight: ['28px', '32px'],
                    whiteSpace: 'nowrap'
                }
            }
        },
        '.hero-container': {
            position: 'absolute',
            top: '50%',
            left: ['15px', '75px'],
            transform: 'translate(-50%, -50%)',
            display: 'block',
            width: ['300px', '450px'],
            overflow: 'hidden',
            padding: '25px',
            margin: ['0', '0', '20px']
        },
        '.hero-container.Center': {
            left: '50%',
            margin: 'auto',
            textAlign: 'center'
        },
        '.hero-container.Left-Top': {
            margin: 'auto',
            textAlign: 'center',
            top: '30px',
            left: ['15px', '75px'],
            transform: 'unset'
        },
        '.hero-container.Left-Bottom': {
            margin: 'auto',
            top: 'unset',
            transform: 'unset',
            bottom: ['15px', '30px']
        },
        '.hero-container.Left-Center': {
            left: '20%',
            right: 'unset',
            margin: 'auto',
            textAlign: 'center'
        },
        '.hero-container.Center-Top': {
            left: '0',
            right: '0',
            margin: 'auto',
            textAlign: 'center',
            top: '30px',
            transform: 'unset'
        },
        '.hero-container.Center-Bottom': {
            left: '0',
            right: '0',
            margin: 'auto',
            textAlign: 'center',
            top: 'auto',
            bottom: '30px',
            transform: 'unset'
        },
        '.hero-container.Right-Top': {
            left: 'unset',
            right: ['15px', '75px'],
            margin: 'auto',
            textAlign: 'center',
            top: '30px',
            transform: 'unset'
        },
        '.hero-container.Right-Bottom': {
            left: 'unset',
            right: ['15px', '75px'],
            margin: 'auto',
            textAlign: 'center',
            top: 'auto',
            bottom: '30px',
            transform: 'unset'
        },
        '.hero-container.Right-Center': {
            left: 'unset',
            right: ['15px', '75px'],
            margin: 'auto',
            textAlign: 'center',
            transform: 'translate(0, -50%)'
        },
        '.hero-container .hero-text': {
            color: 'white',
            fontWeight: '700',
            marginBottom: ['5px', '10px'],
            lineHeight: 'normal'
        },
        '.hero-container .hero-sub-text': {
            color: 'white',
            fontWeight: '700',
            marginBottom: ['5px', '20px'],
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            webkitBoxOrient: 'vertical',
            display: '-webkit-box',
            webkitLineClamp: '2',
            padding: '0px',
            lineHeight: 'normal'
            /* autoprefixer: off */
        },
        '.rounded-corners': {
            borderRadius: '8px !important'
        },
        '.shop-now-btn': {
            paddingLeft: ['15px !important', '20px !important'],
            paddingRight: ['15px !important', '20px !important'],
            height: 'auto !important'
        },
        '.shop-now-btn a': {
            fontSize: ['12px', '20px'],
            textTransform: 'capitalize',
            lineHeight: ['25px', '50px']
        },
        '.product-tile-block': {
            padding: '10px'
        },
        '.wishlist-icon svg': {
            borderRadius: '50%',
            boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.20)',
            ':hover': {
                '.frame': {
                    fill: 'orangeBaseColor'
                },
                '.wish': {
                    fill: 'white'
                }
            }
        },
        '#chakra-toast-manager-top-right': {
            transform: 'translate(-50%, -50%)',
            position: 'fixed',
            top: '50% !important',
            left: '50% !important',
            right: '0 !important',
            zIndex: '10',

            '.chakra-alert': {
                color: 'rgb(106.08, 0, 0)',
                backgroundColor: 'rgb(244.8, 204, 204)',
                borderColor: 'rgb(240.72, 183.6, 183.6)',
                borderRadius: '0',
                boxShadow: '1px 1px 5px grey',
                padding: '1em',
                textAlign: 'center',

                '.chakra-alert__icon, .chakra-icon': {
                    display: 'none'
                },

                '.chakra-alert__title': {
                    color: 'rgb(106.08, 0, 0)',
                    fontWeight: '400',
                    margin: '0'
                },

                '&[data-status="success"]': {
                    color: 'rgb(0, 70.72, 20.28)',
                    backgroundColor: 'rgb(204, 231.2, 211.8)',
                    borderColor: 'rgb(183.6, 221.68, 194.52)',

                    '.chakra-alert__title': {
                        color: 'rgb(0, 70.72, 20.28)'
                    }
                }
            },

            '.chakra-toast': {
                transform: 'none !important',
                marginBottom: '16px'
            },

            '.chakra-toast__inner': {
                margin: '0 auto',
                minWidth: 'auto'
            }
        },
        '.hideMobile .chakra-popover__popper': {
            transform: 'none !important',
            width: '100% !important',
            position: 'inherit !important'
        },
        '.quantity-picker-dropdown .chakra-select__icon-wrapper': {
            marginRight: '10px !important'
        },
        '.atcCancelButtons button .StripeElement': {
            width: '100%'
        },

        '.sf-product-list-page .einsteinRecommendations .product-items-inner-block .product-tile-block':
            {
                backgroundColor: 'white !important'
            },
        '#pwa-studio-ghibli h1': {
            fontSize: '2rem',
            marginBottom: '.5rem',
            fontWeight: '500',
            lineHeight: '1.2'
        },
        '.header-banner-desktop a': {
            color: 'white',
            fontSize: 'md',
            fontWeight: 'medium',
            lineHeight: '6'
        },
        ':disabled': {
            cursor: 'default !important'
        },
        '.slick-list': {
            overflow: 'hidden'
        },
        '.footer-login-block': {
            display: 'none'
        },
        '.footer-account-block': {
            display: 'none'
        },
        '.customer-registered .footer-account-block': {
            display: 'block'
        },
        '.customer-guest .footer-login-block': {
            display: 'block'
        },
        '.slick-disabled': {
            cursor: 'default'
        },
        '.ot-sdk-show-settings': {
            cursor: 'pointer'
        },
        '.cart-secure-payment': {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            '.secure-title-block': {
                display: 'none'
            },
            '.secure-payment-text': {
                color: 'slateGray',
                fontSize: 'sm',
                fontWeight: 'medium',
                lineHeight: 5,
                mb: 2,
                textAlign: 'center'
            },
            '.social-icons': { 
                width: '80%',
                margin: '0 auto',
                textAlign: 'center',
                svg: {
                    margin: '0 3px 6px',
                    display: 'inline-block'
                }
            }
        }
    }
}
